const features = [
  {
    icon: 'ri-stack-line',
    title: '全系列收录',
    desc: '刃牙漫画完整版从第一部到最新连载，一次性收录全部章节，刃牙漫画大全触手可及。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '优化刃牙漫画下拉式阅读体验，无需翻页等待，流畅畅享全系列。电脑手机自适应。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续同步更新',
    desc: '刃牙漫画合集同步最新连载进度，第一时间更新，不错过每一话的精彩对决。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定可靠',
    desc: '平台采用稳定技术架构，保障刃牙漫画在线看的流畅体验。内容仅供学习交流使用。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          为什么选择刃牙漫画？四大优势让你畅享热血格斗世界
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}